import { Button, Checkbox, Col, Input, Modal, Row, Select, Table, Form } from 'antd';
import Column from 'antd/lib/table/Column';
import React, { useContext, useEffect, useState } from 'react';
import Services from '../../network/Services';
import konsole from '../../network/konsole';
import { ModalBody } from 'react-bootstrap';
import './Agreement.css'
import { UserContext } from '../../App';
import { completeEventMessage } from '../../control/Constant';
const { Option } = Select;


const Template = () => {
      const loginUserID = sessionStorage?.getItem("loggedUserId");
      const subtenetId = sessionStorage?.getItem('subtenantId');
      const [number, setNumber] = useState(1);
      const [agreementList,setAgreementList] = useState([]);
      const [openModal,setOpenmodal] = useState(false);
      const [editDetails,setEditdetails] = useState({'subAgtId':0,item: '',subscriptionId: '2',subsPlanId: '3',subtenantId: '2',isFlatFee: true,isHourly: true,isIncluded: true,subscriptionPlanName:''})
      const [currItem,setCurritem] = useState('A')
      const [currItemsub,setCurritemsub] = useState(1)
      const [rateCardlist,setRatecardlist] = useState([])
      const [selectedRatecard,setSelectedratecard] = useState('')
      const [selectedRatecards, setSelectedRatecards] = useState([]);
      const { setLoader } = useContext(UserContext);



      useEffect(()=>{
        if(subtenetId == null) return;
        fetchRatecardlist(subtenetId,2)
        if(agreementList?.length > 0) return;
        fetchAgreementListfunc(subtenetId)
      },[])

      useEffect(()=>{
        setCurritemsub(1)
      },[currItem])

      const fetchAgreementListfunc = (subtenetId) => {
        setLoader(true)
        const promise = Services.getSubtenantAgreement(subtenetId);
        promise.then((response)=>{
          setLoader(false)
            konsole.log(response,"_response")
            konsole.log(response.data.data,"responsedatadata")
            let subItemList =[]
            let itemList = []
            response?.data?.data?.map((e)=>{
              let splitName = e?.item?.split('-')
              konsole.log(splitName,"splitName",e)
              if(splitName.length > 1){
                subItemList.push(e)
                let filteredi = itemList?.filter((s)=>{return s.item == splitName[0] && s?.subsPlanId == e?.subsPlanId})[0]
                let allData = itemList?.filter((s)=>{return s?.subAgtId != filteredi?.subAgtId})
                let mergeArr = []
                konsole.log(itemList,e,"subItemListsubItemList12",filteredi,splitName,"splitName")
                if(filteredi != undefined){
                filteredi = {...filteredi,subItemlist:[e]}
                mergeArr = [...allData,filteredi]
                itemList = mergeArr;
                konsole.log(itemList,"subItemListsubItemList11",filteredi,splitName,"splitName")
                }
                // else{
                //   filteredi = {subItemlist:[e]}
                //   mergeArr = allData
                // }
                // itemList = mergeArr;
                setCurritemsub(splitName[1])
                konsole.log(itemList,"subItemListsubItemList1",filteredi)

              }else{
                konsole.log(e,"eeeeeeeeeeee")
                itemList.push(e)
                let nextCode = e.item.charCodeAt(0) + 1;
                if (nextCode > 90) nextCode = 65;
                setCurritem(String.fromCharCode(nextCode))
                konsole.log(itemList,"subItemListsubItemList2")

              }
            })
            konsole.log(itemList,"subItemListsubItemList",subItemList)
            setAgreementList(itemList)
        }).catch((error)=>{
            setLoader(false)
            konsole.log(error,"error")
        })
      }

      const fetchRatecardlist = (subtenetId,subscriptionId) => {
        const promise = Services.getratecardlist(subtenetId,subscriptionId);
        promise.then((response)=>{
          konsole.log(response,'fetchRatecardlistresponse')
          setRatecardlist(response?.data?.data[0]?.subsPlans)
        }).catch((error)=>{
          konsole.log(error,'error')
        })
      }

    const managebeneficiries = (num) => {
        setNumber(num);
        const newURL = window.location.origin + window.location.pathname + `?view=${num}`
        window.history.pushState({ path: newURL }, '', newURL);
      };

    const addnewAgreement = (data) => {
      let filterdata = agreementList.filter((a)=>{return a.subsPlanId == data.subsPlanId});
      let itemValue = currItem;

      let nextCode = filterdata[filterdata.length - 1].item.charCodeAt(0) + 1;
      if (nextCode > 90) nextCode = 65;
      itemValue = String.fromCharCode(nextCode);
      // setCurritem(itemValue)

      let newItem = {
        ...editDetails,
        subAgtId:0,
        item: itemValue,
        subscriptionId: '2',
        subsPlanId: data.subsPlanId,
        serviceProvider:"",
        subtenantId: '2',
        isFlatFee: true,
        isHourly: true,
        isIncluded: true,
        subscriptionPlanName:data.subscriptionPlanName,
      };

      setAgreementList((prev) => [...prev, newItem]);

      setCurritem((prev) => {
        let nextCode = prev.charCodeAt(0) + 1;
        if (nextCode > 90) nextCode = 65;
        return String.fromCharCode(nextCode);
      });

    };

    const onChangeservice = (type,value,itemAgreement) => {
      let filterData = agreementList.filter((e)=> e.item == itemAgreement.item && e.subsPlanId == itemAgreement.subsPlanId)[0]

      setAgreementList((prev) => {
        const indexToUpdate = prev.findIndex(
          (e) => e.item === itemAgreement.item && e.subsPlanId === itemAgreement.subsPlanId
        );

        if (indexToUpdate !== -1) {
          const newList = [...prev];
          newList[indexToUpdate] = { ...newList[indexToUpdate], ...filterData,  [type]: value };
          return newList;
        }
        return [
          ...prev.filter((e) => e.item !== itemAgreement.item && e.subsPlanId !== itemAgreement.subsPlanId),
          { ...filterData, [type]: value },
        ];
      });
    }

    const onChangeserviceSub = (type, value, itemAgreement, subsItem) => {
      setAgreementList((prev) => {
        const indexToUpdate = prev.findIndex(
          (e) => e.item === itemAgreement.item && e.subsPlanId === itemAgreement.subsPlanId
        );

        if (indexToUpdate !== -1) {
          const updatedAgreement = { ...prev[indexToUpdate] };

          updatedAgreement.subItemlist = updatedAgreement.subItemlist.map((subItem) => {
            if (subItem.item === subsItem.item) {
              return { ...subItem, [type]: value };
            }
            return subItem;
          });

          const newList = [...prev];
          newList[indexToUpdate] = updatedAgreement;
          return newList;
        }
        return prev;
      });
    };


    const addnewsubAgreement = (item) => {
      let existingAgreement = agreementList?.find(e => e.item === item.item && e.subsPlanId == item.subsPlanId);

      if (!existingAgreement) {
        konsole.error("Agreement not found");
        return;
      }

      let existingSubItems = existingAgreement?.subItemlist || [];
      let lastIndex = 0;
      if (existingSubItems.length > 0) {
        const maxIndex = Math.max(...existingSubItems.map(sub => {
          const parts = sub.item.split('-');
          return Number(parts[1]) || 0;
        }));
        lastIndex = maxIndex;
      }

      const newSubItem = {
        ...editDetails,
        subsPlanId:existingAgreement?.subsPlanId,
        item: `${item.item}-${lastIndex + 1}`,
      };

      const updatedAgreement = {
        ...existingAgreement,
        subItemlist: [...existingSubItems, newSubItem],
      };

      setAgreementList(prev => {
        return prev.map(agreement =>
          agreement.item === item.item  && agreement.subsPlanId == item.subsPlanId ? updatedAgreement : agreement
        );
      });
    };


    const onSavebtn = () => {
      konsole.log(agreementList,"agreementListagreementListagreementListagreementList")
      let postJson = agreementList?.map((e) => {

        const parentJson = {
          "subAgtId": e?.subAgtId != undefined && e?.subAgtId != null && e?.subAgtId !== '' ? e?.subAgtId : 0,
          "subtenantId": 2,
          "subscriptionId": e.subscriptionId,
          "subsPlanId": e.subsPlanId,
          "item": e.item,
          "isIncluded": true,
          "isHourly": true,
          "isFlatFee": true,
          "descOfService": "",
          "serviceProvider": e.serviceProvider,
          "cost": 0,
          "isCostIncluded": true,
          "isActive": true,
          "rateCardIds":Array.isArray(e?.rateCardIds) ? e?.rateCardIds?.filter((rt)=>{return rt != null})?.toString() :e?.rateCardIds ,
          "upsertedBy": loginUserID
        };

        const subItemJson = e?.subItemlist?.map((eSub) => {
          konsole.log(eSub,"fdjhfjdhfdj",e)
          return {
            "subAgtId": eSub?.subAgtId != undefined && eSub?.subAgtId != null && eSub?.subAgtId !== '' ? eSub?.subAgtId : 0,
            "subtenantId": 2,
            "subscriptionId": eSub.subscriptionId,
            "subsPlanId": eSub.subsPlanId,
            "item": eSub.item,
            "isIncluded": true,
            "isHourly": true,
            "isFlatFee": true,
            "descOfService": "",
            "serviceProvider": eSub.serviceProvider,
            "rateCardIds":Array.isArray(eSub?.rateCardIds) ? eSub?.rateCardIds?.filter((rt)=>{return rt != null})?.toString() :eSub?.rateCardIds,
            "cost": 0,
            "isCostIncluded": true,
            "isActive": true,
            "upsertedBy": loginUserID
          };
        });

        return subItemJson != undefined ? [parentJson, ...subItemJson] : parentJson;
      }).flat();

      konsole.log(postJson,"postJsonpostJson",agreementList)
      // return;
      upsertAgreementFunc('post',postJson)
    }

    const deleteFunc = (e,index) => {
      let filterItem = {...e,isActive:false,upsertedBy:loginUserID}

      if(e?.subItemlist?.length > 0){
        let subItemlistActive = e?.subItemlist?.map((subi)=>{
          return {
            ...subi,isActive:false,upsertedBy:loginUserID
          }
        })
        filterItem = [filterItem,...subItemlistActive]
      }

      let postJson = [filterItem]?.flat()

      upsertAgreementFunc('delete',postJson)
    }

    const upsertAgreementFunc = (type,postJson) => {
      setLoader(true)
      const upsertAgreementpromise = Services.upsertAgreementdata(postJson)
      upsertAgreementpromise.then((response)=>{
        setLoader(false)
        konsole.log(response,"__response")
        if(type == "delete"){
          completeEventMessage('success','Data deleted successfully.')
          fetchAgreementListfunc(subtenetId)
          return
        }
        completeEventMessage('success','Data saved successfully.')
        fetchAgreementListfunc(subtenetId)
      }).catch((error)=>{
        setLoader(false)
        konsole.log(error,"error")
      })
    }

    konsole.log(agreementList,"agreementList")
    return (
        <div className="w-100 h-100">
        <h3 className="mt-2 p-1 fw-bold">Agreement Template</h3>
        <div className="col-12 d-flex m-2" style={{ paddingTop: "8px" ,borderBottom:"1px solid #474747"}} >
        {/* <button className={number == 1 ? "schedule-active me-2 schedule  fw-bold  border-gray" : "me-2 schedule  fw-bold  border-gray"} onClick={() => managebeneficiries(1)}>Fee Agreement</button>  */}
        </div>
        <Row>
          <div className="headerAgreement"><p>Subscription Plan</p> <p>Item</p> <p>Service Provider</p> <p>Hourly | Flat Fee</p> <p>Rate Card</p> <div className="d-flex gap-2"><p>Add Item | Sub Item</p> <p>Delete</p></div></div>
          {agreementList?.sort((a,b)=>{return a.subscriptionPlanName.localeCompare(b.subscriptionPlanName)})?.map((e,index)=>{
          let isSubitem = e.item.slice(-2,-1) == "-" ? true : false;
          return <>
            <div className="d-flex justify-content-between gap-2 w-100 p-10 align-items-center">
            <p className="w-20">{agreementList[index - 1]?.subscriptionPlanName != e.subscriptionPlanName ? e.subscriptionPlanName : ""}</p>
            <p>{e.item}</p>
            {/* <p>{e.serviceProvider}</p> */}
            <textarea className="w-25 form-control" placeholder="Enter the service provider" value={e.serviceProvider} onChange={(v)=>{onChangeservice("serviceProvider",v.target.value,e)}} />
            <Checkbox checked={e?.isHourly} onClick={(v)=>onChangeservice("isHourly",v.target.checked,e)} />
            <Checkbox checked={e?.isFlatFee} onClick={(v)=>onChangeservice("isFlatFee",v.target.checked,e)} />
            <div className='w-25'>
            <Select
                mode='multiple'
                maxTagCount={"responsive"}
                // disabled={disabledselect}
                // defaultValue="Select Provided plan"
                placeholder="Select Provided plan"
                className="w-100 selectInput"
                // dropdownMatchSelectWidth
                defaultValue={Array.isArray(e?.rateCardIds) ? e?.rateCardIds : e?.rateCardIds?.split(',') }
                onChange={(ertc) => onChangeservice("rateCardIds",ertc,e)}>
                {rateCardlist?.filter((rtc)=>{return rtc.subsPlanId == e.subsPlanId })[0]?.subsPlanSKUs?.map((dataprop) => (
                <Option value={dataprop.subsPlanSKUMapId?.toString()} key={dataprop.subsPlanSKUMapId} >
                {dataprop.skuListName}
                </Option>
                ))}
            </Select>
            </div>
            {(isSubitem || e.itemSub == true ) ? <p>-</p> :<buttton className="d-flex justify-content-center cursor-pointer align-items-center" style={{border:"1px solid #720c20",backgroundColor:"#720c20",width:"25px",height:"25px",fontSize:"18px",color:"white",borderRadius:"8px"}} onClick={()=>{addnewAgreement(e)}}>+</buttton>}
            {(isSubitem || e.itemSub == true) ? <p>-</p> :<buttton className="d-flex justify-content-center cursor-pointer align-items-center" style={{border:"1px solid #720c20",backgroundColor:"#720c20",width:"25px",height:"25px",fontSize:"18px",color:"white",borderRadius:"8px"}} onClick={()=>{addnewsubAgreement(e)}}>+</buttton>}
            <img className="cursor-pointer" width="20px" src="images/delete-icon.png" onClick={()=>deleteFunc(e,index)} />
            <br/>
            </div>
            {e?.subItemlist?.map((subs)=>(
            <li className="d-flex justify-content-between gap-2 w-100 p-10" key={index}>
            <p className="w-20"></p>
            <p><div className="black-dot me-1"></div>{subs.item}</p>
            <textarea className="w-25 form-control" placeholder="Enter the service provider" value={subs.serviceProvider} onChange={(v)=>{onChangeserviceSub("serviceProvider",v.target.value,e,subs)}} />
            <Checkbox checked={subs?.isHourly} onClick={(v)=>onChangeserviceSub("isHourly",v.target.checked,e,subs)} />
            <Checkbox checked={subs?.isFlatFee} onClick={(v)=>onChangeserviceSub("isFlatFee",v.target.checked,e,subs)} />
            <div className='w-25'></div>
            <div className='mx-3'>-</div>
            <div className="mx-3">-</div>
            <div></div>
            <div className='me-3'><img className="cursor-pointer" width="20px" src="images/delete-icon.png" onClick={()=>deleteFunc(subs,index)} /></div>
            </li>))}
          </>})}
        </Row>
          <div className="d-flex justify-content-end">
            <button className="saveBtn" onClick={()=>onSavebtn()}>Save</button>
          </div>
        <br/>
        <br/>
        </div>
    )
}
export default Template;